
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
// @ is an alias to /src

@Component
export default class BoxEntriesHeaderName extends Vue {
  private name = 'BoxEntriesHeaderName';
  @Prop()
  private str!: string;
}
